<div class="background">
  <a (click)="closeModal()"><i class="fa-solid fa-xmark"></i></a>
  <app-document-renderer *ngIf="popUpText" [document]="popUpText.document"></app-document-renderer>
</div>
